import React, { Component } from 'react';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import moment from 'moment';
import queryString from 'query-string';
import Shortlist from '../../components/shortlist';
import Error from '../../components/error';
import Loading from '../../components/loading';
import { Button } from 'semantic-ui-react';

import UserDetailsModal from '../../components/user-details-modal';

const _ = require('lodash');

const resetButtonStyles = {
  width: '150px',
  margin: '10px 0',
};

const PROFILE_KEY = 'DYZIO_PROFILE';

class ShortlistContainer extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      shortlist: null,
      error: null,
      shortlistId: null,
    };

    this.client = axios.create({
      // baseURL: process.env.REACT_APP_API_URL,
      baseURL: 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/shortlists',
      timeout: 30000,
    });

    axiosRetry(this.client, {
      retries: 3,
      delay: 100,
      retryCondition: error => !error.response || (error.response.status >= 500 && error.response.status <= 599),
    });
  }

  componentDidMount = () => {
    const { shortlistId } = this.props.match.params;

    const qs = this.props.location.search;

    const parsed = queryString.parse(qs);
    console.log(parsed);
    let email = parsed.email || null;
    let isProfileSet = false;

    if (!email) {
      const profile = this.getProfile();
      console.log(profile);
      email = profile && profile.email;
      isProfileSet = _.has(profile, 'email');
    }

    console.log(email);
    // put the email into local storage
    // https://www.npmjs.com/package/localStorage
    // https://www.npmjs.com/package/local-storage

    // create a form with name and email
    this.setState({
      shortlistId,
      email,
      isProfileSet,
    });

    this.client.get(`/${shortlistId}`)
      .then(r => {
        const shortlist = r.data.data;
        const { linksMap, links } = r.data;
        if (shortlist.status !== 'COMPLETED') {
          this.handleViewed();
        }
        this.setState({
          loading: false,
          shortlist,
          linksMap,
          links,
        });
      })
      .catch(error => {
        window.onerror(error);
        this.setState({
          error,
        });
      });
  }

  resetProfile = () => {
    localStorage.setItem(PROFILE_KEY, null);
    this.setState({
      profile: null,
      email: null,
      isProfileSet: false,
    });
  }

  getProfile = () => {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem(PROFILE_KEY);
    return profile ? JSON.parse(profile) : null;
  }

  setProfile = profile => {
    console.log(profile);
    localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
    this.setState({
      profile,
      email: profile.email,
      isProfileSet: true,
    });
  }

  handleApprove = (user, influencerId) => {
    const { email } = this.state;
    const approval = { influencerId,
      type: 'APPROVE',
      message: `${email} approved on ${moment(new Date()).format('DD MMM YYYY')}`,
    };

    this.postApproval(approval);
  }

  handleReject = (user, influencerId) => {
    const { email } = this.state;
    const approval = { influencerId,
      type: 'REJECT',
      message: `${email} rejected on ${moment(new Date()).format('DD MMM YYYY')}`,
    };

    this.postApproval(approval);
  }

  handleSubmit = () => {
    const { shortlistId } = this.state;
    this.client.patch(`/${shortlistId}`, {
      data: {
        status: 'COMPLETED',
      },
    }).then(r => {
      const newShortlist = r.data.data;
      const { shortlist } = this.state;
      shortlist.status = newShortlist.status;
      this.setState({
        shortlist,
      });
    })
      .catch(error => {
        this.setState({
          error,
        });
      });
  }

  handleViewed = () => {
    const { shortlistId } = this.state;
    this.client.patch(`/${shortlistId}`, {
      data: {
        status: 'VIEWED',
      },
    }).then(r => {
      console.log('status set to VIEWED');
    });
  }

  postApproval = approval => {
    const { shortlistId } = this.state;
    this.client.post(`/${shortlistId}`, {
      data: {
        approval,
      },
    }).then(r => {
      const newShortlist = r.data.data;
      const { shortlist } = this.state;
      shortlist.dataMap = newShortlist.dataMap;
      this.setState({
        shortlist,
      });
    })
      .catch(error => {
        this.setState({
          error,
        });
      });
  }

  render = () => {
    const { shortlist, loading, error, linksMap, links, isProfileSet, email } = this.state;
    const { isShortlistApprovalDisabled } = shortlist || {};
    console.log(error);
    if (shortlist) {
      return (
        <div>
          <Shortlist
            shortlist={shortlist}
            linksMap={linksMap}
            links={links}
            loading={loading}
            onApprove={this.handleApprove}
            onReject={this.handleReject}
            onSubmit={this.handleSubmit}
          />
          {
            !email && !isShortlistApprovalDisabled &&
            <div>
              <UserDetailsModal
                open={!isProfileSet}
                resourceType="shortlist"
                successHandler={this.setProfile}
              />
            </div>
          }
          {
            isProfileSet && !isShortlistApprovalDisabled &&
            <div>
              <Button
                basic
                negative
                style={resetButtonStyles}
                onClick={this.resetProfile}
                content="reset profile"
              />
            </div>
          }
        </div>
      );
    }

    if (error) {
      return (
        <Error error={error} />
      );
    }

    return (
      <Loading resource="shortlist" />
    );
  }
}

export default ShortlistContainer;



// WEBPACK FOOTER //
// ./src/containers/shortlist/index.js